import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * Translated titles for maplibre-gl's built-in controls, in the shape the map `locale` option expects.
 * Reuses the same keys the Leaflet `map-controls.tsx` used, so both engines read identically.
 *
 * `locale` is init-only (maplibre-gl has no `setLocale`), so this covers the first render and
 * `useMapLibreControlTooltips` patches the buttons on a later language switch.
 */
export const useMapLibreMapLocale = (): Record<string, string> => {
  const { t } = useTranslation();

  /* eslint-disable @typescript-eslint/naming-convention -- fixed maplibre-gl locale keys, not renameable */
  return useMemo(
    () => ({
      "NavigationControl.ZoomIn": t("general.zoomIn"),
      "NavigationControl.ZoomOut": t("general.zoomOut"),
      "FullscreenControl.Enter": t("general.enterFullscreen"),
      "FullscreenControl.Exit": t("general.exitFullscreen"),
    }),
    [t],
  );
  /* eslint-enable @typescript-eslint/naming-convention */
};
